
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CWorkplacePlaceholder extends Vue {}
